export default "__VITE_ASSET__eb92c584__"